module.exports = __webpack_public_path__ + "static/media/linkedin.637d6249.svg";